import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';

@Component({
  selector: 'ip-board-collaborative-sticker-input',
  templateUrl: './ip-board-collaborative-sticker-input.component.html',
  styleUrls: ['./ip-board-collaborative-sticker-input.component.scss']
})
export class IPBoardCollaborativeStickerInputComponent implements OnInit {
  @Input()
  ipBoard: IPBoard;
  @Input()
  ipBoardPart: IPBoardPart;
  @Input()
  label = 'Links';
  @Output()
  save = new EventEmitter<any>();

  withSticker: boolean = false;
  hide: boolean = true;

  ngOnInit(): void {
    this.withSticker = !StringHelper.isEmpty(this.ipBoardPart.otherSticker);
  }

  withStickerChanged(): void {
    if (!this.withSticker) {
      this.ipBoardPart.otherSticker = null;
      this.save.emit();
    }
  }
}
